import React from 'react';
import {connect} from 'react-redux';
import { useParams } from 'react-router-dom';
import _ from 'underscore';
import AuctioneerPage from '../components/AuctioneerPage/AuctioneerPage';
import {
    prepareAuctioneerPage
} from '../ducks';
import {
    getTransform,
    OBJECT_AUCTIONEER,
    OBJECT_AUCTION
} from '../utils/sources';

// Connected component that receives auctioneerId as a prop
const ConnectedAuctioneerPage = connect(
    (state, { auctioneerId }) => {
        let transformAuctioneer = getTransform(OBJECT_AUCTIONEER);
        let transformAuction = getTransform(OBJECT_AUCTION);

        // Handle both new normalized structure and legacy array format
        const auctionsData = state.auctions.data;
        let auctionItems = [];
        let totalPages = null;
        let totalItems = null;

        if (auctionsData) {
            if (auctionsData.items) {
                // New normalized structure: { items: [...], totalPages, totalItems }
                auctionItems = auctionsData.items;
                totalPages = auctionsData.totalPages;
                totalItems = auctionsData.totalItems;
            } else if (Array.isArray(auctionsData)) {
                // Legacy: plain array
                auctionItems = auctionsData;
            }
        }

        return {
            auctioneerId: auctioneerId,
            auctioneer: transformAuctioneer(state.auctioneer.data),
            auctioneerLoading: state.auctioneer.loading,
            auctions: _(auctionItems).map(transformAuction),
            auctionsLoading: state.auctions.loading,
            hideHeader: !auctioneerId,
            totalPages: totalPages,
            totalItems: totalItems,
        };
    },
    (dispatch, { auctioneerId }) => ({
        onInitialize: () => dispatch(prepareAuctioneerPage(auctioneerId))
    })
)(AuctioneerPage);

// Wrapper component that extracts params and passes them to connected component
function AuctioneerPageContainer(props) {
    const { auctioneerId } = useParams();
    return React.createElement(ConnectedAuctioneerPage, Object.assign({}, props, { auctioneerId: auctioneerId }));
}

export default AuctioneerPageContainer;
